import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const CancellationDetailsModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: .67em;
`
CancellationDetailsModalWrapper.displayName = 'CancellationDetailsModalWrapper'

export const ItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 1rem;
`
ItemWrapper.displayName = 'ItemWrapper'

export const TextSubTitle = styled.div`
	color: ${colorTheme.cancellationDetailsModal.subTitle};
	font-family: ${theme.fontRoboto};
	font-size: 1em;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`
TextSubTitle.displayName = 'TextSubTitle'

export const Text = styled.div`
	color: ${colorTheme.cancellationDetailsModal.text};
	font-family: ${theme.fontRoboto};
	font-size: 1.25em;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`
Text.displayName = 'Text'

export const CancellationDetailsModalBtnWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 1.88em;

	@media screen and (max-width: ${theme.point820}) {
		> button {
			width: 100%;
		}
	}
`
CancellationDetailsModalBtnWrapper.displayName = 'CancellationDetailsModalBtnWrapper'
